import { setCookie } from "../helpers/jwt";
import { ACCESS_TOKEN } from "../constants/constants";
import { USER_MANAGEMENT_BASE_URL } from "../constants/apiUrl";
import { logoutCallback } from "../helpers/shared";
class AuthService {
  constructor() {
    this.isRefreshing = false;
    this.refreshTokenPromise = null;
  }

  async handle401Error() {
    if (this.isRefreshing && this.refreshTokenPromise) {
      return this.refreshTokenPromise;
    }

    this.isRefreshing = true;
    this.refreshTokenPromise = (async () => {
      try {
        const url = `${USER_MANAGEMENT_BASE_URL}/auth/accessToken`;
        const response = await fetch(url, { credentials: "include" });
        if (response.status === 401) {
          return "401";
        }
        if (response.ok) {
          const tokenResponse = await response.json();
          setCookie(ACCESS_TOKEN, tokenResponse.accessToken);
        }
      } catch (error) {
        console.error("Failed to refresh token:", error);
        return "401";
      } finally {
        this.isRefreshing = false;
        this.refreshTokenPromise = null;
      }
    })();
    return this.refreshTokenPromise;
  }
}

export const authService = new AuthService();
